import { useState } from "react";
import PagePopopCloseButton from "components/page-components/PagePopopCloseButton";
import ReturnIdentitySteps from "./ReturnIdentitySteps";
import ReturnIdentityFail from "./ReturnIdentityFail";
import { useRefreshItems } from "hooks/useRefreshItems";
import { useRemoveActiveItem } from "hooks/useRemoveActiveItem";
import ModalWindow from "components/ModalWindow";

const ReturnIdentityPopup = ({ close }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [step, setStep] = useState("start");
  const refresh = useRefreshItems();
  const removeActiveItem = useRemoveActiveItem();

  const closeWindow = () => {
    if (step === 'fail' || step === 'success') {
      refresh();
      removeActiveItem();
      close();
    } else close()
  }

  return (
    <ModalWindow close={close}>
      <div
        className="modal-window__wrapper"
        onClick={(e) => e.stopPropagation()}
      >
        <PagePopopCloseButton close={closeWindow} />
        {step !== "fail" ?
          <ReturnIdentitySteps
            step={step}
            setStep={setStep}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            close={closeWindow}
          />
          :
          <ReturnIdentityFail close={closeWindow} />
        }
      </div>
    </ModalWindow>
  );
};

export default ReturnIdentityPopup;
